import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Icon } from 'semantic-ui-react';
import i18next from 'i18next';

import '../DataGrid.scss';

class NumericFilter extends Component {

    render() {
        const { filter, filterMinMax, onChange, ...rest } = this.props;

        return (
            <div>
                <input
                    type="number"
                    min={filterMinMax.min ? filterMinMax.min : 0}
                    max={filterMinMax.max ? filterMinMax.max : 100}
                    onChange={event => onChange({ numeric: true, content: event.target.value })}
                    placeholder={i18next.t('choose')}
                    value={filter ? filter.value.content : ''}
                    className='pi-data-grid-filter-component pi-data-grid-filter-numeric'
                />
                {
                    filter && filter.value.content ?
                        <button className='pi-data-grid-filter-clear' onClick={() => onChange({ numeric: true, content: '' })}>
                            <Icon name="close" color="grey" />
                        </button>
                        : null
                }
            </div>
        );

    }
}

NumericFilter.propTypes = {
    filter: PropTypes.object,
    filterMinMax: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
};

export default NumericFilter;